export const fetchDocuments = payload => {
    return {
      type: "FETCH_DOCUMENTS",
      payload
    };
  };

  export const setDocumentsListPageSize = payload => {
    return {
      type: "SET_DOCUMENTS_LIST_PAGE_SIZE",
      payload
    };
  };

  export const setDocumentsListPageCurrent = payload => {
    return {
      type: "SET_DOCUMENTS_LIST_PAGE_CURRENT",
      payload
    };
  };

  export const setSelectedDocumentRows = payload => {
    return {
      type: "SET_SELECTED_DOCUMENTS_ROWS",
      payload
    };
  };

  export const resetDocumentsFilters = payload => {
    return {
      type: "INIT_DOCUMENTS_FILTER",
      payload
    };
  };

  export const setDocumentsTypesFilter = payload => {
    return {
      type: "SET_DOCUMENTS_TYPES_FILTER",
      payload
    };
  };

  export const setDocumentsPeriodsFilter = payload => {
    return {
      type: "SET_DOCUMENTS_PERIODS_FILTER",
      payload
    };
  };

  export const setDocumentSearchFilter = payload => {
    return {
      type: "SET_DOCUMENTS_SEARCH_FILTER",
      payload
    };
  };

  export const setDocumentAppFilter = payload => {
    return {
      type: "SET_DOCUMENT_APP_FILTER",
      payload
    };
  };

  export const setDocumentCancelFilter = payload => {
    return {
      type: "SET_DOCUMENTS_CANCEL_FILTER",
      payload
    };
  };


  export const fetchDocumentsApp = payload => {
    return {
      type: "FETCH_DOCUMENTS_APP",
      payload
    };
  };

  export const fetchDocument = payload => {
    return {
      type: "FETCH_DOCUMENT",
      payload
    };
  };

  export const modifyDocument = payload => {
    return {
      type: "MODIFY_DOCUMENT",
      payload
    };
  };

  export const alterDocumentPageStore = payload => {
    return {
      type: "ALTER_DOCUMENT_PAGE_STORE",
      payload
    };
  };

  export const regenerateAndSendDocument = payload => {
    return {
      type: "REGENERATE_SEND_DOCUMENT",
      payload
    };
  };

  export const getDocumentLinesForDocument = payload => {
    return {
      type: "GET_DOCUMENT_LINE_FOR_DOCUMENT",
      payload
    };
  };

  export const getPaymentForDocument = payload => {
    return {
      type: "GET_PAYMENT_FOR_DOCUMENT",
      payload
    };
  };


  export const fetchDocumentsAppRef = payload => {
    return {
      type: "FETCH_DOCUMENTS_APP_REF",
      payload
    };
  };

  export const setDocumentAppRefFilter = payload => {
    return {
      type: "SET_DOCUMENT_APP_REF_FILTER",
      payload
    };
  };

  export const setDocumentStatusFilter = payload => {
    return {
      type: "SET_DOCUMENT_STATUS_FILTER",
      payload
    };
  };

  export const getDocumentStats = payload => {
    return {
      type: "GET_DOCUMENT_STATS",
      payload
    };
  };

  export const getCountDocumentsForFtpUpload = payload => {
    return {
      type: "GET_COUNT_DOCUMENTS_FTP_UPLOAD",
      payload
    };
  };



// WEBPACK FOOTER //
// ./app/actions/actions/documents.js